import { Breakpoint, Dialog, DialogTitle, IconButton } from '@mui/material';
import { SxProps, Theme } from '@mui/system';
import React from 'react';

export interface IBaseDialogProps {
  open: boolean;
  /** Zavolá sa pri X alebo programovom zatvorení. NIKDY nie pri kliku mimo / Esc. */
  onClose: () => void;
  title?: React.ReactNode;
  maxWidth?: Breakpoint | false;
  fullWidth?: boolean;
  /** Zobraziť X vpravo hore (default true). */
  showClose?: boolean;
  id?: string;
  children?: React.ReactNode;
  /** Voliteľné doladenie MUI Dialog (napr. presná šírka cez '& .MuiDialog-paper') */
  sx?: SxProps<Theme>;
}

/**
 * Spoločný základ pre všetky modaly v aplikácii.
 * - Nezatvára sa klikom mimo (backdrop) ani klávesom Esc — len cez X / tlačidlá.
 * - Voliteľné X vpravo hore.
 * Použitie: `<XsBaseDialog open onClose title>...<DialogContent/><DialogActions/>...</XsBaseDialog>`
 */
export const XsBaseDialog = ({
  open,
  onClose,
  title,
  maxWidth = 'sm',
  fullWidth = true,
  showClose = true,
  id,
  children,
  sx
}: IBaseDialogProps) => (
  <Dialog
    id={id}
    open={open}
    onClose={(_e, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      onClose();
    }}
    maxWidth={maxWidth}
    fullWidth={fullWidth}
    disableEscapeKeyDown
    sx={sx}
  >
    {showClose && (
      <IconButton
        onClick={onClose}
        size='small'
        aria-label='close'
        style={{ position: 'absolute', right: 8, top: 8, zIndex: 1 }}
      >
        <i className='fal fa-times' />
      </IconButton>
    )}
    {title != null && <DialogTitle>{title}</DialogTitle>}
    {children}
  </Dialog>
);
